/* Chilli Bomba — free shipping progress bar
   Keeps the bar in sync with the cart without a page reload.
   Listens for any /cart/add|change|update|clear call and re-reads /cart.js. */
(function () {
  'use strict';

  function bar() { return document.querySelector('[data-cb-ship-bar]'); }

  function money(cents) {
    return '$' + (Math.abs(cents) / 100).toFixed(2);
  }

  var lastTotal = null;

  function render(total) {
    var el = bar();
    if (!el) return;

    var threshold = parseInt(el.getAttribute('data-cb-threshold'), 10) || 4500;
    var remaining = threshold - total;
    var pct = remaining > 0 ? Math.min(100, (total / threshold) * 100) : 100;

    var fill  = el.querySelector('[data-cb-ship-fill]');
    var track = el.querySelector('[data-cb-ship-track]');
    var head  = el.querySelector('[data-cb-ship-head]');
    var sub   = el.querySelector('[data-cb-ship-sub]');
    if (!fill || !head) return;

    fill.style.width = pct.toFixed(1) + '%';
    if (track) track.setAttribute('aria-valuenow', String(Math.round(pct)));

    if (remaining > 0) {
      el.classList.remove('is-free');
      head.textContent = "You're " + money(remaining) + ' from free shipping';
      if (sub) sub.textContent = "Add one more bag and we'll cover the postage.";
    } else {
      el.classList.add('is-free');
      head.textContent = 'Free shipping unlocked';
      if (sub) sub.textContent = 'Nice work. The postage is on us.';
    }

    // bump only when the number actually moved, so it stays a signal not a tic
    if (lastTotal !== null && lastTotal !== total) {
      el.classList.remove('cb-bump');
      void el.offsetWidth;
      el.classList.add('cb-bump');
    }
    lastTotal = total;
  }

  function refresh() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c.total_price); })
      .catch(function () {});
  }

  var CART_WRITE = /\/cart\/(add|change|update|clear)/;

  // fetch
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (CART_WRITE.test(url)) {
        p.then(function () { setTimeout(refresh, 60); }).catch(function () {});
      }
      return p;
    };
  }

  // XHR, for older cart scripts and some apps
  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cbCartWrite = CART_WRITE.test(String(url || ''));
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__cbCartWrite) {
        this.addEventListener('load', function () { setTimeout(refresh, 60); });
      }
      return origSend.apply(this, arguments);
    };
  }

  window.cbShipBar = { refresh: refresh, render: render };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      var el = bar();
      if (el) {
        var f = el.querySelector('[data-cb-ship-fill]');
        if (f) lastTotal = null;
      }
      refresh();
    });
  } else {
    refresh();
  }
})();
